const footerLinks = [
  { href: "#home", label: "首页" },
  { href: "#features", label: "核心功能" },
  { href: "#anime", label: "热门番剧" },
  { href: "#guide", label: "线路指南" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-50">
      <div className="container-site flex flex-col gap-10 py-14 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="md:col-span-1">
            <a href="#home" className="flex items-center gap-2 font-heading text-2xl font-bold">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50">
                <i className="ri-clapperboard-line" aria-hidden="true"></i>
              </span>
              小猴看番
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/80">
              聚合多线路播放源,自动选源与手动秒切结合,解决看番卡顿,多源播放稳定追更。
            </p>
          </div>

          <nav className="md:col-span-1" aria-label="页脚导航">
            <h3 className="font-heading text-base font-bold">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-background-100/80 transition-colors hover:text-secondary-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-1">
            <h3 className="font-heading text-base font-bold">联系与支持</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-300" aria-hidden="true"></i>
                support@xiaohoukamfan.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-remote-control-line text-secondary-300" aria-hidden="true"></i>
                7×24 小时线路自动巡检
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-secondary-300" aria-hidden="true"></i>
                全站 HTTPS 安全访问
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/15 pt-6">
          <p className="text-center text-xs leading-relaxed text-background-100/60">
            本站为信息展示网站,仅提供线路切换与多源播放的使用指南与功能说明。请合理观看内容,并遵守当地法律法规。
          </p>
          <div className="mt-3 flex flex-col items-center justify-between gap-2 text-xs text-background-100/60 sm:flex-row">
            <span>© 2026 小猴看番 版权所有</span>
            <span>多线路聚合 · 稳定追更</span>
          </div>
        </div>
      </div>
    </footer>
  );
}